module.exports = __webpack_public_path__ + "static/turquia-025-da16d8b88ad81da941a91750a2fdc0e5.jpg";